module.exports = __webpack_public_path__ + "static/img/09.b2e22e36.png";